import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.ORDER_SET_ORDER_LIST]: (state, payload) => {
    state.meta = 'meta' in payload ? payload.meta : null
    state.summary = payload.data.summary
    state.orderList = payload.data.orderList
    state.orderIncompleteList = payload.data.orderIncompleteList
    state.orderList = payload.data.orderList
  },
  [mutationsTypes.ORDER_SET_ORDER_INCOMPLETE_LIST]: (state, payload) => {
    state.orderIncompleteList = payload.notificationList
  },
  [mutationsTypes.ORDER_SET_ORDER_PAYMENT_LIST]: (state, payload) => {
    state.orderPaymentList = payload.paymentList
  },
  [mutationsTypes.ORDER_SET_ORDER_DETAIL_LIST]: (state, payload) => {
    state.orderDetailList = payload.orderList
  },
  [mutationsTypes.ORDER_BULK_OPERATION_FLG]: (state, flag) => {
    state.bulkOperationCompleted = flag
  }
}

export default Mutations
